module.exports = {
  custom_audiences: [
    {
      method: 'GET',
      url: '/custom-audiences',
      query_params: 'q, limit, skip, sort, fields',
      sample: 'https://datasphere-api.sharethis.com/custom-audiences?',
    },
    {
      method: 'GET',
      url: '/custom-audiences/schema',
      query_params: '',
      sample: 'https://datasphere-api.sharethis.com/custom-audiences/schema?',
    },
    {
      method: 'GET',
      url: '/custom-audiences/enum/:field',
      query_params: '',
      sample: 'https://datasphere-api.sharethis.com/custom-audiences/enum/languages?',
    },
    {
      method: 'GET',
      url: '/custom-audiences/:id',
      query_params: '',
    },
    {
      method: 'POST',
      url: '/custom-audiences/:id',
      query_params: '',
    },
    {
      method: 'PUT',
      url: '/custom-audiences/:id',
      query_params: '',
    },

    {
      method: 'DELETE',
      url: '/custom-audiences/:id',
      query_params: '',
    },
  ],
  // DEPRECATED: I think...
  legacy_audiences: [
    {
      method: 'GET',
      url: '/legacy-audiences/:id',
      query_params: '',
      sample: 'https://datasphere-api.sharethis.com/legacy-audiences?id=5b44d7dc3e13c5001bdbe58e&',
    },
    {
      method: 'GET',
      url: '/legacy-audiences/search',
      query_params: 'q, limit, skip, sort, fields, kind',
      sample:
        'https://datasphere-api.sharethis.com/legacy-audiences/search?kind=custom&limit=25&q=&skip=0&sort=updated_at%2C-1&',
    },
    {
      method: 'GET',
      url: '/legacy-audiences/:id',
      query_params: '',
      sample:
        'https://datasphere-api.sharethis.com/legacy-audiences/insights?id=5b44d7dc3e13c5001bdbe58e&',
    },
  ],
  pixel_audiences: [
    {
      method: 'GET',
      url: '/pixel-audiences',
      query_params: 'q, limit, skip, sort, fields',
      sample: 'https://datasphere-api.sharethis.com/pixel-audiences?',
    },
    {
      method: 'GET',
      url: '/pixel-audiences/schema',
      query_params: '',
      sample: 'https://datasphere-api.sharethis.com/pixel-audiences/schema?',
    },
    {
      method: 'GET',
      url: '/pixel-audiences/enum/:field',
      query_params: '',
      sample: 'https://datasphere-api.sharethis.com/pixel-audiences/enum/vertical?',
    },
    {
      method: 'GET',
      url: '/pixel-audiences/:id',
      query_params: '',
      sample: 'https://datasphere-api.sharethis.com/pixel-audiences/5e0be5234b5e910012a54b60?',
    },
    {
      method: 'POST',
      url: '/pixel-audiences/:id',
      query_params: '',
    },
    {
      method: 'PUT',
      url: '/pixel-audiences/:id',
      query_params: '',
    },
    {
      method: 'DELETE',
      url: '/pixel-audiences/:id',
      query_params: '',
    },
  ],
  branded_audiences: [
    {
      method: 'GET',
      url: '/legacy-audiences/search',
      query_params: 'q, limit, skip, sort, fields, is_branded=true, kind=taxonomy',
      sample:
        'https://datasphere-api.sharethis.com/legacy-audiences/search?is_branded=true&kind=taxonomy&limit=25&q=&skip=0&sort=updated_at%2C-1&',
    },
  ],
  white_label_audiences: [
    {
      method: 'GET',
      url: '/legacy-audiences',
      query_params: 'q, limit, skip, sort, fields, is_branded=false, kind=taxonomy',
      sample:
        'https://datasphere-api.sharethis.com/legacy-audiences/search?is_branded=false&kind=taxonomy&limit=25&q=&skip=0&sort=updated_at%2C-1&',
    },
  ],
  data_feeds: [
    {
      method: 'GET',
      url: '/data-feeds',
      query_params: 'q, limit, skip, sort, fields',
      sample: 'https://datasphere-api.sharethis.com/data-feeds?',
    },
    {
      method: 'GET',
      url: '/data-feeds/schema',
      query_params: '',
      sample: 'https://datasphere-api.sharethis.com/data-feeds/schema?',
    },
    {
      method: 'GET',
      url: '/data-feeds/enum/:field',
      query_params: '',
      sample: 'https://datasphere-api.sharethis.com/data-feeds/enum/input_feeds?',
    },
    {
      method: 'GET',
      url: '/data-feeds/:id',
      query_params: '',
      sample: 'https://datasphere-api.sharethis.com/data-feeds/5dfd274be4c1780012f3e312?',
    },
    {
      method: 'POST',
      url: '/data-feeds/:id',
      query_params: '',
    },
    {
      method: 'PUT',
      url: '/data-feeds/:id',
      query_params: '',
    },
    {
      method: 'DELETE',
      url: '/data-feeds/:id',
      query_params: '',
    },
  ],
  partners: [
    {
      method: 'GET',
      url: '/partners',
      query_params: 'q, limit, skip, sort, fields',
      sample: 'https://datasphere-api.sharethis.com/partners?',
    },
    {
      method: 'GET',
      url: '/partners/schema',
      query_params: '',
      sample: 'https://datasphere-api.sharethis.com/partners/schema?',
    },
    {
      method: 'GET',
      url: '/partners/:id',
      query_params: '',
      sample: 'https://datasphere-api.sharethis.com/partners/5df9711f26fde35e075e036b?',
    },
    {
      method: 'POST',
      url: '/partners/:id',
      query_params: '',
    },
    {
      method: 'PUT',
      url: '/partners/:id',
      query_params: '',
    },
    {
      method: 'DELETE',
      url: '/partners/:id',
      query_params: '',
    },
  ],
  destinations: [
    {
      method: 'GET',
      url: '/destinations',
      query_params: 'q, limit, skip, sort, fields',
      sample: 'https://datasphere-api.sharethis.com/destinations?',
    },
    {
      method: 'GET',
      url: '/destination/schema',
      query_params: '',
      sample: 'https://datasphere-api.sharethis.com/destinations/schema?',
    },
    {
      method: 'GET',
      url: '/destinations/:id',
      query_params: '',
      sample: 'https://datasphere-api.sharethis.com/destinations/5d6ef2e0c09cc20019fd9efa?',
    },
    {
      method: 'POST',
      url: '/destinations/:id',
      query_params: '',
    },
    {
      method: 'PUT',
      url: '/destinations/:id',
      query_params: '',
    },
    {
      method: 'DELETE',
      url: '/destinations/:id',
      query_params: '',
    },
  ],
  regions: [
    {
      method: 'GET',
      url: '/regions',
      query_params: 'q, limit, skip, sort, fields',
      sample: 'https://datasphere-api.sharethis.com/pixel-audiences?',
    },
    {
      method: 'GET',
      url: '/regions/schema',
      query_params: '',
      sample: 'https://datasphere-api.sharethis.com/regions/schema?',
    },
    {
      method: 'GET',
      url: '/regions/enum/:field',
      query_params: '',
      sample: 'https://datasphere-api.sharethis.com/regions/enum/countries?',
    },
    {
      method: 'GET',
      url: '/regions/:id',
      query_params: '',
      sample: 'https://datasphere-api.sharethis.com/regions/5dd87a5f9f575bd8834205a3?',
    },
    {
      method: 'POST',
      url: '/regions/:id',
      query_params: '',
    },
    {
      method: 'PUT',
      url: '/regions/:id',
      query_params: '',
    },
    {
      method: 'DELETE',
      url: '/regions/:id',
      query_params: '',
    },
  ],
  authentication: [
    {
      method: 'GET',
      url: '/facebook/connect',
      query_params: '',
    },
    {
      method: 'GET',
      url: '/facebook/callback',
      query_params: '',
    },
    {
      method: 'GET',
      url: '/google/connect',
      query_params: '',
    },
    {
      method: 'GET',
      url: '/google/callback',
      query_params: '',
    },
    {
      method: 'GET',
      url: '/self',
      query_params: '',
    },
    {
      method: 'GET',
      url: '/team/:id',
      query_params: '',
    },
    {
      method: 'POST',
      url: '/register',
      query_params: '',
    },
    {
      method: 'POST',
      url: '/login',
      query_params: '',
    },
    {
      method: 'POST',
      url: '/forgot-password',
      query_params: '',
    },
    {
      method: 'POST',
      url: '/reset-password',
      query_params: '',
    },
    {
      method: 'POST',
      url: '/update-profile',
      queru_params: '',
    },
  ],
}
